const appConstants = {
    url: {
        linkedin: 'https://www.linkedin.com/in/luca-dillenburg/',
        github: 'https://github.com/lucadillenburg',
        emailQuota: 'mailto:luca.assumpcao.dillenburg@gmail.com?subject=Mobile%20App%20Quota%20-%20%5BBusiness%20Name%5D&body=Dear%20Mr.%20Dillenburg%2C%0D%0A%0D%0AI%20am%20interested%20in%20your%20design%20and%20development%20services%20and%20I%20would%20like%20to%20get%20a%20quota.%0D%0A%0D%0ABusiness%20Explanation%3A%20%0D%0AApp%20Explanation%3A%20%0D%0AThe%20single%20most%20important%20app%20feature%3A%20%0D%0ADo%20you%20already%20have%20a%20brand%20identity%3F%20%5BYes%2FNo%5D%0D%0A%0D%0ABest%20regards%2C',
        apps: {
            legumo: {
                appStore: 'https://apps.apple.com/br/app/legumo/id1589305379?l=en',
                playStore: 'https://play.google.com/store/apps/details?id=br.com.legumo',
                video: 'https://youtu.be/0Xkny4qKbn0',
            },
            do: {
                appStore: 'https://apps.apple.com/br/app/do/id1639581703?l=en',
                playStore: 'https://play.google.com/store/apps/details?id=br.dillenburg.doapp',
                video: 'https://youtu.be/KwQnbh3medE',
            },
        },
    },
};

export default appConstants;
